import { ENUM_INBOUND_ROLE } from 'utils/enum';
import * as yup from 'yup';

export const repSchema = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  cokitchenId: yup.string().required('Cokitchen is required'),
  phoneNumber: yup
    .string()
    .matches(/^0[0-9]{10}$/, 'Phone number must be 10 digits')
    .optional(), //required('Phone number is required')

  email: yup.string().email('Invalid email format').optional(), //required('Email is required'),
  role: yup
    .mixed<ENUM_INBOUND_ROLE>()
    .oneOf(Object.values(ENUM_INBOUND_ROLE), 'Invalid role')
    .required('Role is required')
});

export type CSRepFormType = yup.InferType<typeof repSchema>;
